<div class="modal-body error-body">


  <div class="row">
    <h4 class="error-text ml-4 mt-2">{{'messages.error-occurred' | translate}}</h4>
  </div>
  <div class="row">
    <div class="col-md-12 text-center">
      <img src="../../../../assets/images/error_image.png" style="max-height: 150px;"/>


      <!-- <p *ngIf="notOurError" class="text-danger">
      Something went wrong trying to process your request, please try again later!
  </p> -->

      <div *ngIf="errorMessageReason.length > 0">
        <p class="error-description-header"> {{errorMessage}}</p>
        <p class="error-description"> {{errorMessageReason}}</p>
      </div>

      <div *ngIf="errorMessageReason.length <= 0">
        <p class="text-danger">{{errorMessage}}</p>
      </div>

      <!-- If traceReference exists, show it -->
      <div *ngIf="traceReference">
        <hr>

        <p style="margin-bottom: 0;">{{'messages.error-number' | translate}}: <strong>{{ traceReference }}</strong>
          <span>
          <button class="iso-button-icon-only error-button-copy" (click)="copyClipboard()">
            <daz-icon class="iso-button-icon-error" [name]="'copy'" [size]="'20px'" [color]="'#6B728C'"></daz-icon>
          </button></span>
        </p>
        <p>{{'messages.error-assistance' | translate}}
        </p>

      </div>

      <button class="iso-round-button iso-light error-button"
              (click)="modal.dismiss('Cross click')">{{'messages.error-okay' | translate}}</button>

    </div>
  </div>

</div>

<p-toast position="bottom-center" styleClass="hubtiger-toast"></p-toast>
